import Router from '@/router'
import { clearAuthStorage } from '@/libs/auth/clearStorage'
import {
  TOKEN_KEY,
  PROFILE_KEY,
  BRANCH_ID,
} from '@/libs/acl/config'

export default {
  namespaced: true,
  state: {
    token: localStorage.getItem(TOKEN_KEY) || null,
    profile: JSON.parse(localStorage.getItem(PROFILE_KEY)) || {
      isAdmin: false,
    },
    branchId: localStorage.getItem(BRANCH_ID) || null
  },
  getters: {
    token: state => state.token || null,
    profile: state => state.profile || {},
    branchId: state => state.branchId || null,
  },
  mutations: {
    setToken(state, token) {
      localStorage.setItem(TOKEN_KEY, token)
      state.token = token
    },
    setProfile(state, profile) {
      localStorage.setItem(PROFILE_KEY, JSON.stringify(profile))
      state.profile = profile
    },
    clearSession(state) {
      state.token = null
      state.profile = { isAdmin: false }
      state.branchId = null
    },
  },
  actions: {
    login({ commit, dispatch }, { userName, password }) {
      dispatch(
        'app/create',
        { url: 'Users/auth', data: { userName: userName, password: password } },
        { root: true },
      ).then(data => {
        commit('setToken', data.token)
        commit('setProfile', data)
        Router.push('/')
      })
    },
    logout({ commit }) {
      clearAuthStorage()
      commit('clearSession')
      if (this.state.app) {
        this.state.app.branchId = 0
        this.state.app.currentBranch = {}
        this.state.app.currentCompany = {}
        this.state.app.currentYear = {}
        this.state.app.userCurrentYear = 0
        this.state.app.branches = []
        this.state.app.fiscalYears = []
      }
      Router.push({ name: 'login' })
    },
    changePassword() {
      Router.push('/change-password')
    },
  },
}
